module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/AERONAUTICAL ENGINEERING-e875590fba2d5d73cf6ff50c9bd7a5f4.png";